import {
  ANNULATIONS_FETCH
} from '../constants/ActionTypes';

export default (state = [], action) => {
  switch (action.type) {
    case ANNULATIONS_FETCH: {
      return action.payload;
    }
    default:
      return state;
  }
};
